export function setSession(username: string, password: string, security_control?: string, security_code?: string) {
    sessionStorage.setItem('username', username);
    sessionStorage.setItem('password', password);
    sessionStorage.setItem("security_control", security_control)
    sessionStorage.setItem("security_code", security_code)
}

export function removeSession() {
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('password');
    sessionStorage.removeItem("security_control")
    sessionStorage.removeItem("security_code")
}

export function getSession(): Promise<[string, string, string, string]> {
    return Promise.all(
        [
            sessionStorage.getItem('username'),
            sessionStorage.getItem('password'),
            sessionStorage.getItem('security_control'),
            sessionStorage.getItem('security_code'),
        ],
    ).then(([username, password, security_control, security_code]) => [username || 'default', password || 'default', security_control || 'default', security_code || 'default']);
}
